<script lang="ts" setup>
import AdkButton from '@components/ui/AdkButton.vue'
import { useCartActions } from '@composables/useCartActions'
import { useLocale } from '@composables/useLocale'
import { useGtm } from '@composables/useGtm'
import { LogoutType } from '@lib/models/gtm'
import { useRoute, useRouter } from 'vue-router'

const props = defineProps<{
  onPress?: () => void
}>()

const { t } = useLocale()
const route = useRoute()
const router = useRouter()
const { sendReset } = useCartActions()
const { trackGoBack } = useGtm()

const actionBackOrCancel = async () => {
  if (props.onPress) {
    props.onPress()
    return
  }

  const routeName = route.name as string

  switch (routeName) {
    case 'prehome':
      await sendReset(LogoutType.CANCELLATION)
      break
    case 'home':
      trackGoBack()
      router.push({ name: 'prehome' })
      break
    case 'cart':
    case 'category':
    case 'loyalty':
    case 'aop-coupon':
      router.push({ name: 'home' })
      break
    case 'checkout':
      router.push({ name: 'cart' })
      break
    default:
      router.back()
      break
  }
}
</script>

<template>
  <AdkButton class="w-1/2" size="medium" data-test="btn-back" @press="actionBackOrCancel">
    {{ t('Volver') }}
  </AdkButton>
</template>
